/*
PRDNG-422 raised to start moving common props, methods etc to mixins 
so we have less duplication of code.
*/
import services from "@/components/services";
import { inject } from "vue";

const mixin = {
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", services.resolveTxt);
    const displayParams = inject("displayParams", services.displayParams);
    const getService = inject("getService", services.getService);
    const getMenu = inject("getMenu", services.getMenu);

    return {
      resolveTxt,
      displayParams,
      getService,
      getMenu
    };
  },
  methods: {
    _propogate: function (name, e) {
      // console.log("proporate", name,  e, );
      this.$emit(name, e);
    }
  }
};

export default mixin;
